import { Organization as Org } from 'components/organization/Organization';

export const Organization = (): JSX.Element => (
  <div className="user-profile">
    <Org />
  </div>
);
